export const VERSION = "v23.0-d7b55ea62";
export const SCM_REVISION = "d7b55ea623d1106cb4e1961a4180caf1280ec6ab";